import * as React from 'react';

import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import styles from './styles';

import type { OnlineServiceCategory } from 'tm3-core/api.dtos';

import CategoryCard from './controls/category-card';

import type SearchStore from 'connect/web/src/stores/search-store';
import { SearchType } from 'connect/web/src/stores/search-store';

import { v4 as uuid } from 'uuid';

interface IProps extends WithStyles<typeof styles> {
  categories: OnlineServiceCategory[];
  onClick: (category: OnlineServiceCategory) => void;
  searchStore?: SearchStore;
}

@inject('searchStore')
@observer
class Categories extends React.Component<IProps> {
  componentDidMount() {
    const { searchStore } = this.props;
    if (!!searchStore!.loaded && searchStore!.loading) {
      searchStore?.load();
    }
  }
  render() {
    const {
      classes,
      categories,
      searchStore: { locations }
    } = this.props;
    const { categoriesContainer } = classes;
    const location =
      locations!.filter((x) => x.isMainLocation).find((x) => true) || locations.find(() => true);

    if (categories.length === 0) {
      return (
        <div>
          <p>
            There are no services available to book online at the moment, please contact us directly
            if you wish to book a service. If you have been provided with a direct access link and
            code, please use that to check for available services before contacting us.
          </p>
          {location && (
            <>
              <span>
                To contact us, you can call us on{' '}
                <a href={`tel:${location.telephone}`}>{location.telephone}</a>
              </span>
              {!!location.email && (
                <span>
                  , or send an email to <a href={`mailto:${location.email}`}>{location.email}</a>.
                </span>
              )}
            </>
          )}
        </div>
      );
    }

    const catList = categories.map((category: OnlineServiceCategory) => {
      return <CategoryCard key={uuid()} category={category} onClick={this.onClick} />;
    });
    return <div className={categoriesContainer}>{catList}</div>;
  }

  @action.bound
  private onClick(category: OnlineServiceCategory) {
    this.props.onClick(category);
  }
}

export default withStyles(styles)(Categories);
